import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a49c18c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "total-count" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" open deviations in total ")
const _hoisted_4 = { class: "container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filter-info" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Deviations Overview")
], -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("24 hours")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("7 days")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("30 days")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_popover = _resolveComponent("ion-popover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_Transition, {
        name: "fade",
        appear: ""
      }, {
        default: _withCtx(() => [
          (_ctx.state === 'loaded')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("b", null, _toDisplayString(_ctx.input?.openDeviationsTotal), 1),
                _hoisted_3
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_ion_button, {
        class: "filter-period-button",
        color: "tertiary",
        onClick: _ctx.openPeriodSelector
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.selectedPeriodText), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_ion_popover, {
        "is-open": _ctx.periodSelectorVisible,
        translucent: true,
        event: _ctx.periodSelectorDomEvent,
        "css-class": "popover-period",
        onDidDismiss: _cache[3] || (_cache[3] = ($event: any) => (_ctx.periodSelectorVisible = false))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_item, {
                detail: "false",
                lines: "full",
                button: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectPeriod('24hours')))
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, {
                detail: "false",
                lines: "full",
                button: "",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectPeriod('weekly')))
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, {
                detail: "false",
                lines: "none",
                button: "",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectPeriod('monthly')))
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open", "event"])
    ])
  ], 64))
}